import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  
  grow: {
    flexGrow: 1,
  },
  
  sectionNotif: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexGrow: 1,
    },
  },  
}));
